<template>
  <div>
    <div class="main">
      <list-loading ref="list" :data.sync="list" :page.sync="page" :limit.sync="limit" @loadlist="getData"
                    :threshold="100" :is-show-mod="true">
        <nut-cell slot="list" v-for="(item,index) in list" :key="index" :show-icon="false" class="item">
          <span slot="title">
            <span class="name">{{ item.name }}</span>
          </span>
          <span slot="sub-title">手机号:{{ item.phone }}
            <span style="margin-left: 5px">{{ item.sex == 1 ? '男' : '女' }}</span></span>
          <div slot="avatar">
            <div class="ranking-img ranking-text">{{ index + 1 }}</div>
          </div>
          <div slot="avatar">
            <img class="img-icon" :src='item.avatar ? item.avatar : require("@/resource/img/device/headImg.png")'/>
          </div>
        </nut-cell>
      </list-loading>
      <nut-backtop/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemberList',
  data () {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      list: [],
      page: 1,
      limit: 20
    }
  },
  created () {
    this.urlParam = this.$route.query
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.$api.post({
        url: '/merchant/api/activity/merchant-union-order-usedetail/findFansList',
        data: {
          merId: this.urlParam.merId,
          unionStoreId: this.user.merId,
          page: this.page,
          limit: this.limit
        },
        loading: false
      }).then(res => {
        this.$refs.list.setRes(res)
      })
    },
  }
}
</script>

<style scoped>
.main {
  padding: 50px 0vw 0 0vw;
  font-size: 15px;
}
.img-icon {
  width: 50px;
  height: 50px;
  margin-right: 10px;
  border-radius: 50%;
}

.item .ranking-img {
  width: 21px;
  height: 33px;
  margin-right: 10px;
}

.item .ranking-text {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #8e8e8e;
  font-size: 14px;
}

.item .name {
  display: inline-block;
  white-space: nowrap;
  width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
}
>>> .nut-cell .nut-cell-box {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/active/member/MerUnionFansList.vue